/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Modal } from "react-bootstrap";
import BaseCom from "./BaseCom";
import { qreq } from "../shared/qrequest";

export default class SandboxModal extends BaseCom {

    componentDidMount() {
        qreq.get('/api/data/sandbox/mode', j => {
            if(j.item)
                this.setState({ show: true });
        });
    }

    render() {
        return <Modal show={this.state.show} onHide={() => this.setState({ show: false })} size="lg">

            <Modal.Header closeButton>
                <Modal.Title>Sandbox Mode</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p>This instance is running on sandbox mode for demo purposes. It utilizes a separate database and fake patients.</p>
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-primary" onClick={() => this.setState({ show: false })}>Close</button>
            </Modal.Footer>
        </Modal>;
    }
}